import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-change-version-dialog',
  templateUrl: './change-version-dialog.component.html',
  styleUrls: ['./change-version-dialog.component.scss']
})
export class ChangeVersionDialogComponent implements OnInit {

  justification: String;
  selected;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<ChangeVersionDialogComponent>) {
    this.selected = data.version;
   }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(null);
  }

  send() {
    const dataChangeVersion = {
      version: this.selected,
      justification: this.justification.trim()
    };
    this.dialogRef.close(dataChangeVersion);
  }

  validateDescription() {
    let validation = false;
    if (!this.justification) {
      validation = true;
    } else {
      if (this.justification.trim().length === 0) {
        validation = true;
      }
    }
    return validation;
  }

}
